module.exports = __webpack_public_path__ + "static/media/Logo_white.276677d9.svg";